"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnimatedCaret = void 0;
var _react = _interopRequireWildcard(require("react"));
var _framerMotion = require("framer-motion");
var _animatedCaret = require("@cbhq/cds-common/motion/animatedCaret");
var _context = require("../controls/context");
var _icons = require("../icons");
var _layout = require("../layout");
var _useMotionProps = require("./useMotionProps");
const _excluded = ["rotate", "size", "color", "testID", "spacing", "spacingBottom", "spacingEnd", "spacingHorizontal", "spacingStart", "spacingTop", "spacingVertical"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const AnimatedCaret = /*#__PURE__*/(0, _react.memo)(function AnimatedCaret(_ref) {
  var _useTextInputFocusVar;
  let rotate = _ref.rotate,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 's' : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'foregroundMuted' : _ref$color,
    testID = _ref.testID,
    spacing = _ref.spacing,
    spacingBottom = _ref.spacingBottom,
    spacingEnd = _ref.spacingEnd,
    spacingHorizontal = _ref.spacingHorizontal,
    spacingStart = _ref.spacingStart,
    spacingTop = _ref.spacingTop,
    spacingVertical = _ref.spacingVertical,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const motionProps = (0, _useMotionProps.useMotionProps)({
    enterConfigs: [Object.assign({}, _animatedCaret.animateRotateConfig, {
      toValue: rotate
    })],
    initial: false
  });
  const spacingProps = {
    spacing,
    spacingBottom,
    spacingEnd,
    spacingHorizontal,
    spacingStart,
    spacingTop,
    spacingVertical
  };
  const variant = (_useTextInputFocusVar = (0, _context.useTextInputFocusVariantContent)()) !== null && _useTextInputFocusVar !== void 0 ? _useTextInputFocusVar : color;
  return (
    /*#__PURE__*/
    // HStack to limit rotate boundary
    _react.default.createElement(_layout.HStack, spacingProps, /*#__PURE__*/_react.default.createElement(_framerMotion.MotionConfig, {
      reducedMotion: "user"
    }, /*#__PURE__*/_react.default.createElement(_framerMotion.m.div, _extends({}, motionProps, {
      "data-testid": `${testID}-motion`
    }), /*#__PURE__*/_react.default.createElement(_icons.Icon, _extends({
      color: variant,
      name: "caretUp",
      size: size
    }, rest)))))
  );
});
exports.AnimatedCaret = AnimatedCaret;